<template>
  <ion-page>
    <ion-content ref="content">
      <partials-steps steps="5" active="2" :headline="$t('roofBattens.windzone.headline')"></partials-steps>
      <ion-grid>
        <ion-row>
          <ion-col>
            {{ $t('roofBattens.windzone.select.title') }}
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col class="ion-text-center img-top">
            <div id="img">
              <img src="../../../public/assets/pix/ITW_Windzonen_Belgien.svg" height="160">
              <img src="../../../public/assets/pix/ITW_Windzonen_Niederlande.svg" height="160">
            </div>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col>
            <label for="zone1" class="btn-clickable">
              <ion-col>
                {{ $t('roofBattens.windzone.zone') }} 1
              </ion-col>
              <input id="zone1" v-model="windzone" @click="changePage()" type="radio" value="1">
            </label>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col>
            <label for="zone2" class="btn-clickable" @click="scrollToBottom">
              <ion-col>
                {{ $t('roofBattens.windzone.zone') }} 2
              </ion-col>
              <input id="zone2" v-model="windzone" type="radio" value="2">
            </label>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col>
            <label for="zone3" class="btn-clickable" @click="scrollToBottom">
              <ion-col>
                {{ $t('roofBattens.windzone.zone') }} 3
              </ion-col>
              <input id="zone3" v-model="windzone" type="radio" value="3">
            </label>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col>
            <label for="zone4" class="btn-clickable" @click="scrollToBottom">
                <ion-col>
                  {{ $t('roofBattens.windzone.zone') }} 4
                </ion-col>
              <input id="zone4" v-model="windzone" type="radio" value="4">
            </label>
          </ion-col>
        </ion-row>

        <div v-if="isLageDisabled">
          <ion-row v-if="isLageDisabled">
            <ion-col>{{ $t('roofBattens.windzone.select.additional') }}</ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <label for="binnenland" class="btn-clickable">
                <ion-col>
                  {{ $t('roofBattens.windzone.inland') }}
                </ion-col>
                <input id="binnenland" v-model="lage" @click="changePage()" type="radio" value="Binnenland">
              </label>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <label for="kueste" class="btn-clickable">
                <ion-col>
                  {{ $t('roofBattens.windzone.coast') }}
                </ion-col>
                <input id="kueste" v-model="lage" @click="changePage()" type="radio" value="Küste">
              </label>
            </ion-col>
          </ion-row>
        </div>
        <ion-row>
          <ion-col>
            <div class="hinweis">
              <p><b>{{ $t('roofBattens.windzone.coast') }}</b>: {{ $t('roofBattens.windzone.coastHint.content') }}</p>
              <p>{{ $t('roofBattens.windzone.coastHint.recommendation.title') }} <br>{{ $t('roofBattens.windzone.coastHint.recommendation.class') }}</p>
            </div>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col class="btn-back" size="4" mode="ios">
            <ion-button @click="goBack()">{{ $t('general.back') }}</ion-button>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-content>
  </ion-page>
</template>

<script>
import {
  IonContent,
  IonPage,
  IonButton,
  IonGrid,
  IonRow,
  IonCol
} from '@ionic/vue';
import {defineComponent, ref} from 'vue';
import {store} from "@/store/formtemplate";
import partialsSteps from "@/views/partials/steps";

export default defineComponent({
  name: 'Windzone',
  components: {
    IonContent,
    IonPage,
    IonButton,
    IonGrid,
    IonRow,
    IonCol,
    partialsSteps
  },
  setup() {
    const content = ref();
    const scrollToBottom = () => {
      content.value.$el.scrollToPoint(0, 400, 300);
    }
    return { content, scrollToBottom }
  },
  computed: {
    isLageDisabled() {
      return store.getters.getByProperty("windzone") === "2" || store.getters.getByProperty("windzone") === "3" || store.getters.getByProperty("windzone") === "4";
    },
    windzone: {
      get() {
        return store.getters.getByProperty("windzone")
      },
      set(value) {
        store.commit("set", {property: 'windzone', value: value});

        if(store.getters.getByProperty("windzone") === "1")
          store.commit("set", {property: 'lage', value: "n/a"});
      }
    },
    lage: {
      get() {
        return store.getters.getByProperty("lage")
      },
      set(value) {
        store.commit("set", {property: 'lage', value: value});
      }
    },
  },
  methods: {
    changePage: function () {
      this.$router.push("/Dachlattung/Dachart");
    },
    goBack: function () {
      store.commit("set", {property: 'windzone', value: ""});
      store.commit("set", {property: 'lage', value: ""});

      this.$router.back();
    }
  }
});
</script>
